import React from 'react';
import { Card, CardHeader, CardBody, Badge, Button } from 'reactstrap';
import HTMLEditor2 from '../../../HTMLEditor2';

/*
 * Card with +/- controlled rows of rich-text editors, used for the
 * syllabus and audience lists (event category only).
 * `name` is the form-field key; HTMLEditor2 calls
 * onItemInput(name, index, value, 'item').
 */
const RepeatingHtmlList = ({
  title,
  name,
  idPrefix,
  value = [],
  onAdd,
  onRemove,
  onItemInput,
}) => {
  return (
    <Card className="my-4">
      <CardHeader>
        <div className="d-flex flex-row justify-content-between">
          <div>{title}</div>
          <div>
            <Button
              color="success"
              size="sm"
              style={{ width: '30px' }}
              onClick={onAdd}
            >
              +
            </Button>
            <Button
              color="danger"
              size="sm"
              style={{ width: '30px' }}
              onClick={onRemove}
            >
              -
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        {value.map((item, index) => (
          // rows have no stable identity of their own; index keys match
          // how add/remove operate (append/pop)
          // eslint-disable-next-line react/no-array-index-key
          <div key={`${name}${index}`}>
            <div>
              <Badge>0{index + 1}</Badge>
            </div>
            <div>
              <HTMLEditor2
                id={`${idPrefix}${index}`}
                handleInput={onItemInput}
                value={item.item}
                name={name}
                index={index}
                prop="item"
              />
            </div>
          </div>
        ))}
      </CardBody>
    </Card>
  );
};

export default RepeatingHtmlList;
